export const cpfMask = [
  /\d/,
  /\d/,
  /\d/,
  '.',
  /\d/,
  /\d/,
  /\d/,
  '.',
  /\d/,
  /\d/,
  /\d/,
  '-',
  /\d/,
  /\d/,
];

export const cepMask = [/\d/, /\d/, /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/];

export const phoneMask = (rawValue) => {
  const numbers = rawValue.match(/\d/g);
  let numberLength = 0;
  if (numbers) {
    numberLength = numbers.join('').length;
  }

  if (numberLength > 10) {
    return [
      '(',
      /[1-9]/,
      /[1-9]/,
      ')',
      ' ',
      /\d/,
      /\d/,
      /\d/,
      /\d/,
      /\d/,
      '-',
      /\d/,
      /\d/,
      /\d/,
      /\d/,
    ];
  }
  return ['(', /[1-9]/, /[1-9]/, ')', ' ', /\d/, /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/];
};

export const timeMask = [/\d/, /\d/, 'h', /\d/, /\d/, 'm'];

export const toTimeMask = (amount) => {
  const absAmount = Math.abs(amount);
  let hours = `${Math.trunc(absAmount / 60)}h`;
  let minutes = `${absAmount % 60}m`;

  if (hours.length < 3) {
    hours = `0${hours}`;
  }
  if (minutes.length < 3) {
    minutes = `0${minutes}`;
  }

  const maskedTime = hours + minutes;

  return amount < 0 ? `-${maskedTime}` : maskedTime;
};

export const minuteToHour = (amount) => {
  let m = amount;
  const signal = m < 0 ? '-' : (this.props.positive ? '+' : '');

  if (m < 0) {
    m *= -1;
  }

  if (m !== 0) {
    const hours = Math.floor(m / 60);          
    let minutes = m % 60;
    if (minutes < 9) {
      minutes = `0 ${minutes}`;
    }

    return signal + hours + 'h' + minutes + 'min';
  }

  return '00:00';
};

export const timeMaskToMinutes = (time) => {
  let timeInMinutes = 0;
  if (time.match(/^\d+\dh\d\dm$/)) {
    const timeSplit = time.split(/h|m/);
    if (timeSplit.length > 1) {
      const hoursInMinutes = timeSplit[0] * 60;
      const minutes = Number(timeSplit[1]);
      timeInMinutes = hoursInMinutes + minutes;
    }
  }

  return timeInMinutes;
};
